import {useNavigate} from "react-router-dom";
import {useEffect} from "react";

export default function Redirector(props: {to: string}) {
    const navigate = useNavigate()
    useEffect(() => {
        navigate(props.to, {replace: true})
    }, [navigate, props.to]);
    return <></>
}